import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateGradeLevelsMutation = graphql.persisted(
  "UpdateGradeLevels",
  graphql(`
    mutation UpdateGradeLevels($input: UpdateGradeLevelsInput!) {
      updateGradeLevels(input: $input) {
        school {
          id
          gradeLevelsSetting {
            description
            data
            schema
            items {
              description
              order
            }
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateGradeLevelsMutation };

export function useUpdateGradeLevels() {
  return useMutation(UpdateGradeLevelsMutation);
}
